import { defineCustomElement } from './customElement'
import appConfig from '@/configs/app.config'
// import Root from '@/layout/default.vue'
import App from '@/App.vue'
customElements.define(appConfig.appName, defineCustomElement(App))
